import { BrandBgEntityRaw } from "@common/domain";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomBrandBgEvents } from "../events";
import { RoomBrandBgActions } from "../actions";

export const ROOM_BRAND_BG_FEATURE_KEY = "roomBrandBg";

export interface RoomBrandBgState extends EntityState<Record<string, never>> {
  isLoading: boolean;
  brandBg: null | BrandBgEntityRaw;
}

export const roomBrandBgAdapter: EntityAdapter<Record<string, never>> =
  createEntityAdapter();

const initialState: RoomBrandBgState = roomBrandBgAdapter.getInitialState({
  isLoading: false,
  brandBg: null
});

const reducer = createReducer(
  initialState,
  on(RoomBrandBgActions.roomBrandBgCreate, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandBgActions.roomBrandBgCreateSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgActions.roomBrandBgCreateFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgActions.roomBrandBgDelete, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandBgActions.roomBrandBgDeleteSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgActions.roomBrandBgDeleteFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgActions.roomBrandBgUnUse, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandBgActions.roomBrandBgUnUseSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgActions.roomBrandBgUnUseFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgActions.roomBrandBgUse, (state) => ({
    ...state,
    isLoading: true
  })),
  on(RoomBrandBgActions.roomBrandBgUseSuccess, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgActions.roomBrandBgUseFailure, (state) => ({
    ...state,
    isLoading: false
  })),
  on(RoomBrandBgEvents.roomBrandBgDeleteEvent, (state) => ({
    ...state,
    brandBg: null
  })),
  on(
    RoomBrandBgEvents.roomBrandBgSetEvent,
    (state, { roomBrandBgSetEventVO }) => ({
      ...state,
      brandBg: roomBrandBgSetEventVO.value.brandBg.toJSON()
    })
  )
);

export function roomBrandBgReducer(
  state: RoomBrandBgState | undefined,
  action: Action
) {
  return reducer(state, action);
}
